import { getSupportedLocaleOrDefault, SupportedLocale } from './supported-locales';

/** Intercom help-center locale codes (path segment after domain). */
export const INTERCOM_HELP_CENTER_LOCALES = [
  'en',
  'ca',
  'da',
  'nl',
  'fi',
  'fr',
  'de',
  'it',
  'ja',
  'nb',
  'pl',
  'pt',
  'es',
  'sv',
  'zh-TW',
  'zh-CN',
  'ko',
] as const;

export type IntercomHelpCenterLocale = (typeof INTERCOM_HELP_CENTER_LOCALES)[number];

/** One entry per app locale — adding a SupportedLocale forces updating this map. */
const INTERCOM_LOCALE_BY_SUPPORTED_LOCALE: Record<
  SupportedLocale,
  IntercomHelpCenterLocale
> = {
  [SupportedLocale.En]: 'en',
  [SupportedLocale.EnPs]: 'en',
  [SupportedLocale.CaEs]: 'ca',
  [SupportedLocale.DaDk]: 'da',
  [SupportedLocale.NlNl]: 'nl',
  [SupportedLocale.FiFi]: 'fi',
  [SupportedLocale.FrFr]: 'fr',
  [SupportedLocale.DeDe]: 'de',
  [SupportedLocale.ItIt]: 'it',
  [SupportedLocale.JaJp]: 'ja',
  [SupportedLocale.NbNo]: 'nb',
  [SupportedLocale.PlPl]: 'pl',
  [SupportedLocale.PtPt]: 'pt',
  [SupportedLocale.EsEs]: 'es',
  [SupportedLocale.SvSe]: 'sv',
  [SupportedLocale.ZhTw]: 'zh-TW',
  [SupportedLocale.ZhCn]: 'zh-CN',
  [SupportedLocale.KoKr]: 'ko',
  [SupportedLocale.ArSa]: 'en',
};

/**
 * Maps an in-app locale (BCP-47, e.g. `ja-JP`, `no-NO`) to the locale code
 * used in Intercom help-center URLs (`/{locale}/articles/...`).
 */
export const toIntercomHelpCenterLocale = (
  locale?: string | null
): IntercomHelpCenterLocale => {
  const supported = getSupportedLocaleOrDefault(locale ?? SupportedLocale.En);
  return INTERCOM_LOCALE_BY_SUPPORTED_LOCALE[supported];
};
